import { setPropMutable } from '@ipfabric/utils/fp/prop';

export const indexBy =
  <TItem, TKey extends string = string>(getKey: (item: TItem) => TKey) =>
  (list: readonly TItem[]): Record<TKey, TItem> =>
    list.reduce(
      (acc, item) =>
        setPropMutable<Record<TKey, TItem>>(getKey(item), item)(acc),
      {} as { [Key in TKey]: TItem },
    );
